import { Separator } from "@base-ui/react/separator";
import clsx from "clsx";
import type React from "react";
import { forwardRef } from "react";
import {
  dividerWrapperClass,
  separatorInWrapperClass,
  styledDividerClass,
} from "./styles.css";

interface DividersProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  orientation?: "horizontal" | "vertical";
}

export const Divider = forwardRef(function Divider(
  { label, className, ...props }: DividersProps,
  ref: React.Ref<HTMLDivElement>,
) {
  if (label) {
    return (
      <div className={dividerWrapperClass}>
        <Separator
          ref={ref}
          className={clsx(
            styledDividerClass,
            separatorInWrapperClass,
            className,
          )}
          {...props}
        />
        {label}
        <Separator
          className={clsx(
            styledDividerClass,
            separatorInWrapperClass,
            className,
          )}
          {...props}
        />
      </div>
    );
  }
  return (
    <Separator
      ref={ref}
      className={clsx(styledDividerClass, className)}
      {...props}
    />
  );
});

Divider.displayName = "Divider";
